module.exports = __webpack_public_path__ + "img/stock6.9b9c32ee.png";